import React, { Component, Fragment } from 'react';
import { MSG_ERR, MSG_OK, MSG_WARN } from '../App';
import axios from 'axios';
import LoadingSpinner from './LoadingSpinner';
import EmptyState from './EmptyState';


import cash_icon from "./cash.jpg"
import app_icon from "./bee-icon-png-11.png"
import tips_icon from "./tipsgraduation.png"
import survey_icon from "./SurveyIcon.jpg"

export const CASH_NEWS = 4
export const APP_NEWS = 3
export const TIPS_NEWS = 2
export const SURVEY_NEWS = 1


class NewsFeed extends Component {

    state = {
        newsfeed: [],
        newsloaded: false
    }
    

    getNews = () => {
        const { displayMsg } = this.props;
        let news = []
    
        this.setState({
            newsfeed: [],
            newsloaded: false
        })
        
        axios
            .get('/api/news/')
            .then(res => {
                news = res.data
                this.setState({
                    newsfeed: news,
                    newsloaded: true
                })
            })
            .catch(() => {
                displayMsg("Error al cargar noticias. Intente de nuevo.", MSG_ERR)
            })
        return
    }
    

    componentDidMount() {
  
       this.getNews()
    }
    
   
    render_news = (n, i) => {
        return (
            <div className="d-flex border-top py-2 align-items-flex-start" key={i}>
                <img
                    className="newsfeed-item-icon flex-shrink-0 me-2"
                    src={n.type == CASH_NEWS ? cash_icon :
                         n.type == APP_NEWS ? app_icon :
                         n.type == TIPS_NEWS ? tips_icon :
                         n.type == SURVEY_NEWS ? survey_icon : "NO TYPE"}
                    alt=""
                />
                <div className="flex-grow-1 min-w-0">
                    <div className="fw-bold small">{n.title}</div>
                    <div className="small text-secondary" style={{ lineHeight: 1.3 }}>{n.text}</div>
                </div>
            </div>
        )
    }

    render = () => {
        
  //      const { newsfeed, newsloaded } = this.props;
        if (this.state.newsloaded === false) {
            return <LoadingSpinner message="Cargando noticias…" />
        }
        if (!this.state.newsfeed || this.state.newsfeed.length === 0) {
            return <EmptyState message="No hay noticias disponibles." />
        }
        return (
            <div className="container-fluid flex-1 border-top m-2">
                <div className="navbar-brand mb-2">Noticias</div>
                <div className="list-group list-group-flush">
                    {this.state.newsfeed.map((n, i) => this.render_news(n, i))}
                </div>
            </div>
        )   
        
    }
            
}

 
export default NewsFeed;